import { render } from "./AppointmentCreated.vue?vue&type=template&id=45068ab5&scoped=true"
import script from "./AppointmentCreated.vue?vue&type=script&lang=js"
export * from "./AppointmentCreated.vue?vue&type=script&lang=js"

import "./AppointmentCreated.vue?vue&type=style&index=0&id=45068ab5&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45068ab5"]])

export default __exports__